export const sv = {
  "n1": "förstasida",
  "n2": "Beställa",
  "n3": "handel",
  "n4": "team",
  "n5": "mina",
  "t1": "Något gick fel",
  "t2": "Kopiera framgångsrikt",
  "t3": "Fyll i informationen i sin helhet",
  "t4": "belastning…",
  "t5": "Inloggning framgångsrikt",
  "t6": "Poängen måste vara större än 3 innan du skickar in",
  "t7": "Inlämning framgångsrik",
  "t8": "Otillräcklig balans, kan inte samlas in",
  "t9": "Inlämning misslyckades",
  "t10": "Bind först adressen och den personliga mittsidan kommer att omdirigeras till den personliga mittsidan.",
  "t11": "Adressen har varit bunden, vänligen kontakta kundtjänst för att ändra den",
  "t12": "Modifiering var framgångsrik",
  "t13": "Modifiering misslyckades",
  "t14": "Kontakta kundtjänst för att ändra ditt lösenord",
  "t15": "Lösenordsformatfel",
  "t16": "Framgångsrik tillbakadragande",
  "t17": "Upp för att ta ut kontanter",
  "t18": "Lägsta kontantuttag",
  "t19": "Lösenorden är inkonsekventa två gånger",
  "t20": "antydan",
  "t21": "Kan inte hoppa för tillfället",
  "t22": "Lösenordsformatfel",
  "t23": "Registrerad framgångsrikt",
  "t24": "Ange riktnummer",
  "t25": "Inte mer än",
  "l1": "språk",
  "l2": "Ange ditt kontonummer",
  "l3": "Ange ditt lösenord",
  "l4": "komma ihåg",
  "l5": "Logga in",
  "l6": "Gå för att registrera sig",
  "l7": "Inget konto",
  "l8": "Telefonnummer",
  "l9": "Smicknamn",
  "l10": "lösenord",
  "l11": "Bekräfta lösenord",
  "l12": "Inbjudningskod",
  "l13": "register",
  "l14": "Har redan ett konto",
  "l15": "Gå för att logga in",
  "l16": "Ange ett 6-16-siffriga lösenord",
  "bz1": "hjälp",
  "bz2": "Vanliga frågor",
  "bz3": "Handelsregler",
  "bz4": "Hur man tar ut pengar",
  "bz5": "Hur man fyller på",
  "bz6": "1. Vad är Amazon Review Robot?",
  "bz7": "Amazon Review Robot är ett marknadsföringsföretag som hjälper Amazon att granska robot -butikshandlare runt om i världen få mer orderförsäljning och öka surfdata för Amazon Review Robot Online Store. Vi är engagerade i att etablera en treparts lönsam marknadsföringsmodell mellan Amazon Review Robot och köpmän och konsumenter. Genom att kombinera den senaste P2P -blockchain -tekniken ansluter snabbt konsumenter och köpmän via USDT (TRC20, ERC20). Registrerade användare kan få provisioner på beställningar, medan köpmän kan öka butikens försäljningsdata. Det är den senaste vinstmodellen i Internet Blockchain -modellen!",
  "bz8": "2.Hur fungerar Amazon Robot?",
  "bz9": "Genom Amazon Review Robots dagliga feedback visar det att när du säljer produkter som behöver förbättras säljs på Amazon Review Robot, användare behöver bara klicka på beställningen och systemet automatiskt kommer att generera beställningsprenumerationer. Användare betalar orderbelopp genom blockchain USDT och får dagliga provisioner.",
  "bz10": "3. Varför finns det någon skillnad i priserna på samma valuta i de två transaktionerna?",
  "bz11": "Prisskillnader orsakas av alla faktorer som inte bidrar till den fria cirkulationen av valutor, inklusive hastigheten för valutaöverföring, nätverksförhållanden, valutatillgångsbegränsningar, människors erkännande av valuta genom olika regioner och till och med de typer av transaktionspar som tillhandahålls av utbyten och transaktioner. Därför kan samma valuta skapa prisskillnader i olika transaktioner.",
  "bz12": "4. Investering Vinst?",
  "bz13": "Ju högre priset på det objekt du får, desto högre vinst får du i beställningen. Samtidigt tilldelar Amazon Review Robot slumpmässigt stora uppdragsorder.",
  "bz14": "Varje dag genererar och distribuerar systemet automatiskt 60 produktorder till användare. Stora uppdragsorder tilldelas slumpmässigt.",
  "bz15": "USDT kan ta ut kontanter efter 60 beställningar. (Om 60 beställningar inte är slutförda stannar systemet automatiskt till dagens återstående ordervolym)",
  "bz16": "Varje konto kan bara vara bundet till ett USDT -konto.",
  "bz17": "När du har slutfört leveransen av daglig order kan du ta ut kontanter normalt och anlända inom 24 timmar efter att du startat uttaget och det finns inga begränsningar för uttag.",
  "bz18": "Innan laddning, bind din uttagningsadress (stöder TRC-20) USDT-adress kan du klicka på appen eller webbsidan för att ladda och välja blockchain (TRC-20) du använder för laddning.",
  'bz19': "Återladdning eller överföring av pengar mellan relaterade konton är inte tillåtet. Detta är ett skadligt beteende som griper order och påverkar allvarligt plattformens driftregler. Om sådant beteende upptäcks kommer systemet omedelbart att frysa kontot och diskvalificera arbetet.",
  "ty1": "Säker",
  "ty2": "Avboka",
  "ty3": "överlämna",
  "ty4": "TRC20 -adress",
  "ty5": "ERC20 -adress",
  "s1": "Kumulativ inkomst",
  "s2": "Tjäna",
  "s3": "om oss",
  "s4": "hjälp",
  "s5": "Anteckna",
  "s6": "Min tjänst",
  "d1": "Inte slutförd",
  "d2": "Avslutad",
  "d3": "Inga data än",
  "d4": "Enstaka nummer",
  "d5": "Handelstid",
  "d6": "Belopp",
  "d7": "Nuvarande antal uppgifter",
  "d8": "Förväntade intäkter",
  "d9": "Behov",
  "d10": "göra",
  "j1": "Kontosaldo",
  "j2": "Transaktionsintroduktion",
  "j3": "Amazon Review Robot Använd Amazon Review Robots feedback dagligen för att visa upp produkterna Amazon Review Robot säljer i behov av förbättringar. Användaren behöver bara klicka på beställningen och systemet genererar automatiskt ordersignaturen. Användare betalar orderbeloppet genom USDT -blockchain och får en provision på mer än 0,6% varje gång.",
  "j4": "Börja matcha",
  "j5": "Dagens intäkter",
  "j6": "Slutfört nummer",
  "j7": "Totalt antal uppgifter",
  "td1": "Balans",
  "td2": "provision",
  "td3": "få",
  "td4": "Totalt antal människor",
  "td5": "användare",
  "td6": "medverka",
  "td7": "kvantitet",
  "td8": "ange",
  "g1": "Uttag",
  "g2": "fylla på",
  "g3": "Bjud in vänner",
  "g4": "Bjud in nu",
  "g5": "Du kommer att få en motsvarande andel provision för varje vinst du tjänar efter att ha registrerat en vän",
  "g6": "personlig information",
  "g7": "Finansieringsuppgifter",
  "g8": "Laddningsrekord",
  "g9": "Uttagsrekord",
  "g10": "språk",
  "g11": "Logga ut",
  "g12": "Är du säker på att logga ut?",
  "yh1": "Användarinformation",
  "yh2": "Revidera",
  "yh3": "inrätta",
  "yh4": "Telefon",
  "yh6": "Originalt lösenord",
  "yh7": "Nytt lösenord",
  "mx1": "Ta emot provision",
  "mx2": "inkomst",
  "mx3": "Vägran",
  "mx4": "tid",
  "mx5": "Ladda framgångsrikt",
  "mx6": "Avvisad",
  "mx7": "I avvaktan på",
  "mx8": "Uttagadress",
  "mx9": "Tillgänglig saldo",
  "mx10": "Faktisk kvitto",
  "mx11": "Ange uttagsbeloppet",
  "cz2": "kopiera",
  "cz3": "Valutaval",
  "cz4": "Betala",
  "cz5": "Insättningsadressen stöder endast TRC20-USDT, och lägsta insättningsbelopp är 20USDT.",
  "cz6": "Insättningsadressen stöder endast ERC20, minsta insättningsbelopp är 20USDT",
  "cz1": "Insättningsadressen stöder endast ERC20, minsta insättningsbelopp är 20USDT",
  "qy1": "Riktnummer",
  "yq1": "Bjud in vänner",
  "yq2": "Inbjudningskod",
  "yq3": "Bjuda in vänner och njut av stora vinster",
  "yq4": "Gå och bjud in",
  "zf1": "Laddningsmetod",
  "zf2": "Välj laddningsmetoden",
  "zf3": "Handelsvaluta",
  "zf4": "Handelsnätverk",
  "zf5": "Gå till transaktionen",
  "zf6": "Kopiera framgångsrikt",
  "zf7": "Handelsvaluta",
  "zf8": "Vänligen använd",
  "zf9": "Överför pengar till adressen nedan för att slutföra laddningen.",
  "zf10": "Handelsvaluta",
  "zf11": "kopiera",
  "zf12": "Kontrollera adressen noggrant, felet kommer inte att hämtas",
  "zf13": "Ankomsttid",
  "zf14": "Cirka 1 till 5 minuter",
  "zf15": "Lägsta laddningsbelopp",
  "a1": "Butiksmarknadsföringscenter",
  "a2": "Amazon Market Robot Store Marketing Center är en helt ny plattform utformad för att hjälpa handlare att snabbt öka produktförsäljningen och positiva recensioner, vilket ökar produktens synlighet och synlighet. Användare kan hjälpa handlare genom att slutföra olika uppgifter och få motsvarande belöningar, vilket skapar en win-win-situation för båda parter.",
  "a3": "För närvarande har systemet 30 miljoner användare och 5 miljoner handlare, som marknadsför 70 miljoner produkter dagligen. Vissa handlare har ökat sin butiksförsäljning med 60 % genom att integrera sina produkter i Marketing Center-systemet. Plattformsanvändare klickar helt enkelt på en beställning, och systemet genererar automatiskt en ordersignatur. Efter att orderbeloppet har förbetalts slutförs den virtuella transaktionen och pengarna återförs omedelbart till användarens konto. Användare kan tjäna en extra provision på 0,6 % eller mer varje gång. Systemet tilldelar också slumpmässigt stora bonusordrar för att öka användarprovisionerna.",
  "a4": "Amazon Market Robot lägger stor vikt vid användarnas och handlarnas behov och optimerar och förbättrar kontinuerligt Marketing Center-systemet.",
  // 客服
  "kf1": "Online kundtjänst",
  "kf2": "Manuell kundtjänst uttag",
  "kf3": "Du kan klicka här för att kontakta manuell kundtjänst för uttag",
  "kf4": "Manuell kundtjänst insättning",
  "kf5": "Du kan klicka här för att kontakta manuell kundtjänst för insättning",
  // 支付选项弹窗
  "zf16": "För bankkortstransaktioner, kontakta kundtjänst",
  "zf17": "Kontakta kundtjänst"
}
